import {BillingPlanDto} from "./BillingPlanDto";

export interface SubscriptionStatus {
    status: string,
    nextPaymentDate: number,
    paymentStatus: string,
    amount: number,
    currency: string,
    secret: string,
}

export const isSuccessfulSubscription = (status?: SubscriptionStatus) => {
    return status?.status === "active" || status?.status === "trialing"
}

export interface BillingStatusDto {

    cardDetails?: {
        last4: string,
        expireMonth: number,
        expireYear: number
    }

    plan?: BillingPlanDto;


    subscription?: SubscriptionStatus;
}


